import { postRequest } from "@/utils/client/api";

const createActivity = async (name: string, sessionId: number) => {
  return postRequest("api/activity", { name, sessionId });
};

export default createActivity;
